"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = require("../modules/cart");
var get_element_1 = require("../utils/get_element");
var IDS = {
    FORM: 'js-contents-search-product-form',
    DISPLAY_NUMBER_HIDDEN: 'js-products-display-number-hidden',
    DISPLAY_NUMBER: 'js-products-display-number',
    ORDERBY_HIDDEN: 'js-products-orderby-hidden',
    ORDERBY: 'js-products-orderby',
};
var CLASSES = {
    FILTER_CONDITION_REMOVE_BUTTON: 'js-filter-conditions-remove-button',
    CART_FORM: 'js-cart-form',
};
/**
 * イベントの初期化
 */
var initEvent = function () {
    var form = (0, get_element_1.getElementById)(IDS.FORM);
    /**
     * 表示件数変更イベント
     */
    var initDisplayNumberChangeEvent = function () {
        try {
            var displayNumEl_1 = (0, get_element_1.getElementById)(IDS.DISPLAY_NUMBER);
            displayNumEl_1.addEventListener('change', function () {
                var value = displayNumEl_1.value;
                // 現在のURLパラメータを取得
                var params = new URLSearchParams(window.location.search);
                params.set('disp_number', value); // 表示件数（disp_number）を更新
                params.set('pageno', '1'); // ページ番号（pageno）は1にリセット
                // 新しいURLでページ遷移
                window.location.href = "".concat(window.location.pathname, "?").concat(params.toString());
            });
        }
        catch (_a) {
            return;
        }
    };
    /**
     * 並び替え変更イベント
     */
    var initOrderbyChangeEvent = function () {
        try {
            var orderByEl_1 = (0, get_element_1.getElementById)(IDS.ORDERBY);
            orderByEl_1.addEventListener('change', function () {
                var value = orderByEl_1.value;
                // 現在のURLパラメータを取得
                var params = new URLSearchParams(window.location.search);
                params.set('orderby', value); // 並び替え（orderby）を更新
                params.set('pageno', '1'); // ページ番号（pageno）は1にリセット
                // 新しいURLでページ遷移
                window.location.href = "".concat(window.location.pathname, "?").concat(params.toString());
            });
        }
        catch (_a) {
            return;
        }
    };
    /**
     * 現在の条件削除ボタンのクリックイベント
     */
    var initFilterConditionRemoveButtonClickEvent = function () {
        var removeButtons = document.querySelectorAll(".".concat(CLASSES.FILTER_CONDITION_REMOVE_BUTTON));
        removeButtons.forEach(function (button) {
            button.addEventListener('click', function () { return __awaiter(void 0, void 0, void 0, function () {
                var name, searchCategoryParts, tmpFormData, entries, formData, _i, entries_1, _a, key, value, queryParams, url;
                return __generator(this, function (_b) {
                    name = button.getAttribute('data-category');
                    searchCategoryParts = name ? name.split('-') : [];
                    tmpFormData = new FormData(form);
                    if (!name)
                        return [2 /*return*/];
                    entries = Array.from(tmpFormData.entries());
                    formData = new FormData();
                    for (_i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                        _a = entries_1[_i], key = _a[0], value = _a[1];
                        if (key == searchCategoryParts[0] && value == searchCategoryParts[1]) {
                            // この値だけ除外
                            continue;
                        }
                        formData.append(key, value);
                    }
                    queryParams = new URLSearchParams(Array.from(formData.entries()).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return [key, String(value)];
                    })).toString();
                    url = "".concat(form.action).concat(queryParams);
                    // ページ遷移
                    window.location.href = url;
                    return [2 /*return*/];
                });
            }); });
        });
    };
    /**
     * カートフォームのイベントを初期化
     */
    var initCartFormEvent = function () {
        var cartForms = document.querySelectorAll(".".concat(CLASSES.CART_FORM));
        cartForms.forEach(function (form) {
            (0, cart_1.setupCart)(form, { type: cart_1.CART_TYPE.LIST });
        });
    };
    initDisplayNumberChangeEvent();
    initOrderbyChangeEvent();
    initFilterConditionRemoveButtonClickEvent();
    initCartFormEvent();
};
initEvent();
